import { Action } from "redux";
import { throttle } from "underscore";
import { useAppDispatch } from "../store/reducers/use-typed-selector";
import { PageModuleGroupModules } from "../types/working-model";
import { useScreenMediaQuery } from "../utils/use-screen-media-query";


export const useBelowTheFoldScroll = (
	autoScroll: boolean,
	isPreview: boolean,
	isScrolledPastTheFold: boolean,
	moduleGroupsRefs: React.RefObject<HTMLDivElement>[],
	scrollContainer: React.RefObject<HTMLDivElement>,
	selectedTabUuid: string | undefined | null,
	sessionModuleGrouping: PageModuleGroupModules[] | undefined,
	setIsScrolledPastTheFold: (isScrolledPastTheFold: boolean) => void,
	setSelectedTabUuid: (React.Dispatch<React.SetStateAction<string | undefined>>) | null,
	setActiveSessionGroupModdTabUuid: ((moduleGroupUuid: string | null) => Action) | null,

) => {

	const dispatch = useAppDispatch();

	const {
		isLessThan640
	} = useScreenMediaQuery();

	const handleScroll = throttle(() => {
		const rect = scrollContainer.current?.getBoundingClientRect();
		if (rect) {
			// if screen is less than 640px we immediately fix the video to the top as soon as we scroll,
			// so we only have to cheeck if we have scrolled any amount
			const topOffset = isLessThan640 || !isPreview ? 100 : 180; // 10 for smooth transition given the delay
			const scrolledPast = Math.abs(rect.y - topOffset) > rect.height; // 180 is the height of the header in the admin console


			if (scrolledPast !== isScrolledPastTheFold) {
				setIsScrolledPastTheFold(scrolledPast);
			}

			let lastActive = 0;
			moduleGroupsRefs?.forEach((ref, i) => {
				if (!ref.current) return;
				// 1. What is the current top of the scroll container
				// 2. What is the current tab that is active based on the current position to the top position.
				const moduleRectY = ref?.current?.getBoundingClientRect()?.y - topOffset || 0;
				if (moduleRectY < 0) {
					lastActive = i;
				}
			});

			if (scrolledPast &&
				sessionModuleGrouping?.[lastActive].uuid &&
				selectedTabUuid !== sessionModuleGrouping[lastActive].uuid &&
				!autoScroll
			) {

				if (isPreview) {
					setActiveSessionGroupModdTabUuid && dispatch(setActiveSessionGroupModdTabUuid(sessionModuleGrouping[lastActive].uuid));
				}
				else {
					setSelectedTabUuid && setSelectedTabUuid(sessionModuleGrouping[lastActive].uuid);
				}
			}
		}
	}, 500);

	return handleScroll;
};
